export default class SessionData {
    private static _instance: SessionData;
    public static get Instance(): SessionData {
        if (this._instance == null) this._instance = new SessionData();
        return this._instance;
    }

    selectedPhoto: string;
    endMessages: number[];

    constructor() {
        this.selectedPhoto = "";
        this.refreshEndMessages();
    }

    refreshEndMessages(): void {
        const list: number[] = [];
        const premade = [1, 2, 3, 4, 5];

        for(let i = 0; i < 5; i++) {
            const index = Phaser.Math.RND.between(0, 4-i);
            list.push(premade.splice(index, 1)[0]);
        }

        this.endMessages = list;
    }
}